import type { LeadNeedType, LeadStatus } from '@bcl/shared';

export const needTypeLabels: Record<LeadNeedType, string> = {
  previsite_technique: 'Pré-visite technique',
  chiffrage_travaux: 'Chiffrage des travaux',
  remise_conformite: 'Remise en conformité',
  remise_en_etat: 'Remise en état',
  etude_raccordement: 'Étude de raccordement',
  precablage_telecom: 'Pré-câblage télécom',
  accompagnement_raccordement: 'Accompagnement raccordement',
  autre: 'Autre',
};

export const leadStatusBadge: Record<LeadStatus, { label: string; cls: string }> = {
  recue: { label: 'Reçue', cls: 'bg-gray-100 text-gray-700' },
  prise_en_charge: { label: 'Prise en charge', cls: 'bg-amber-100 text-amber-800' },
  convertie: { label: 'Convertie', cls: 'bg-green-100 text-green-800' },
  rejetee: { label: 'Rejetée', cls: 'bg-red-100 text-red-800' },
};
